import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import moment from "moment";

import QuestionnaireModal from "./QuestionnaireModal";
import AppointmentAssignModal from "./AppointmentAssignModal";
import appointmentService from "../../services/appointmentService";

const AppointmentListItemForm = (props) => {
  const { user, userQuestionnaireId } = props;
  const [litigant, setLitigant] = useState({});

  useEffect(() => {
    if (user !== "" && user !== "0") {
      const id = { id: user };
      appointmentService
        .getLitigant(id)
        .then((payload) => setLitigant(payload));
    }
  }, [user]);
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Row>
            <Col xs={12}>
              {user !== "" && user !== "0" && (
                <React.Fragment>
                  <span>
                    {litigant.lastName}, {litigant.firstName}
                  </span>
                  <br />
                  <span>{moment(litigant.dob).format("MM/DD/YYYY")}</span>
                  <br />
                  <span>{litigant.userName}</span>
                  <br />
                  <QuestionnaireModal
                    buttonLabel="View Questionnaire"
                    color="black"
                    userId={user}
                    qId={userQuestionnaireId}
                    hasCurrentQuestionnaire={true}
                    modalTitle="View Questionnaire"
                    readOnly={true}
                  />
                </React.Fragment>
              )}

              {(user === "" || user === "0") && (
                <React.Fragment>
                  <span>No litigant assigned.</span>
                  <br />
                </React.Fragment>
              )}

              <br />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <AppointmentAssignModal
                buttonLabel="View Questionnaire"
                color="black"
                userId={user}
                qId={userQuestionnaireId}
                hasCurrentQuestionnaire={true}
                modalTitle="View Questionnaire"
                readOnly={true}
                appointmentId={props.appointmentId}
                refreshMonth={props.refreshMonth}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AppointmentListItemForm;
